import { Component } from '@angular/core';
import { BaseBPWizardFormComponent } from '../base-bp-wizard-form.component';
import { BPWizardService } from '../bp-wizard.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../../shared/formly/ga-formly.service';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { LOV_CURRENCY, LOV_LOCAL_CURRENCY, LovService } from '../../../../shared/services/lov.service';
import { TextComponent } from '../../../../shared/text/text.component';
import { StateService, TransitionService } from '@uirouter/angular';
import { BPProfilesDataService } from '../../bp-profiles-data.service';
import { BPProfilesService } from '../../bp-profiles.service';
import { GaValidateService } from '../../../../shared/formly/ga-validate.service';

@Component({
  selector: 'bp-wizard-general',
  template: `
    <h2 [class.step-complete]="stepComplete"><text key="HEADING"></text></h2>
    <formly [form]="form" [model]="model" [fields]="fields"></formly>
  `
})
export class BPWizardGeneralComponent extends BaseBPWizardFormComponent {
  private contractCurrencyField:IExtraFieldConfigurationObject;

  constructor(
    private lovService:LovService,
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    transitionService:TransitionService,
    bpWizardService:BPWizardService,
    bpProfilesService:BPProfilesService,
    bpProfilesDataService:BPProfilesDataService,
    validateService:GaValidateService,
    stateService:StateService
  ) {
    super(transitionService, bpWizardService, bpProfilesService, bpProfilesDataService, validateService, stateService);
  }

  protected createFields():IExtraFieldConfigurationObject[] {
    return [
      this.formlyService.aValue('companyGroup', 'GA.GENERAL.GROUP')
        .withoutEditable()
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withInfo()
        .withFormat(this.formattingService.formatName)
        .build(),
      this.formlyService.aValue('companyName')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .build(),
      this.formlyService.aCustom()
        .withComponent(TextComponent)
        .withoutWrapper()
        .withWrapperClass('double-space-top margin-bottom-xs')
        .withExtraOptions({
          templateOptions: {
            inputs: {
              key: 'CURRENCY'
            }
          }
        })
        .build(),
      this.contractCurrencyField = this.formlyService.aSelect('contractCurrency', 'GA.GENERAL.CURRENCY')
        .withoutEditable()
        .withFormat(this.formattingService.formatCurrencyL)
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withExtraOptions({
          templateOptions: {
            trackBy: !this.model?.country?.id? 'isoCode' : undefined
          }
        })
        .build(),
      this.formlyService.aCustom()
        .withComponent(TextComponent)
        .withoutWrapper()
        .withWrapperClass('triple-space-top margin-bottom-xs')
        .withExtraOptions({
          templateOptions: {
            inputs: {
              key: 'VAT'
            }
          }
        })
        .build(),
      this.formlyService.anInput('taxNumber', this.model.vatName)
        .withoutEditable()
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withPlaceholder()
        .build(),
      this.formlyService.anInput('businessRegistrationNr')
        .withLabelClass(this.labelClass)
        .withValueClass(this.valueClass)
        .withPlaceholder()
        .showInfo()
        .build()
    ];
  }

  protected fillFields():void {
    const countryId:number = this.model?.country?.id;
    const lovCode:string = countryId ? `${LOV_LOCAL_CURRENCY}-${countryId}` : LOV_CURRENCY;
    this.formlyService.fillField(this.contractCurrencyField, this.lovService.list(lovCode));
  }
}